import React from 'react';
import { BringzzBoxSlider, BringzzText, BringzzIcon } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import classNames from 'classnames';

const CategorySlider = ({ categories, activeCategory, onCategorySelect }) => {
    const { navigate } = useNavigation();
    
    const handleCategoryClick = (category) => {
        // Check if this is the local pharmacies category
        if (category.isPharmacyList || category.shortName?.includes('Pharmacies') || category.shortName?.includes('pharmacies')) {
            navigate('/search/local-pharmacies');
            return;
        }
        
        // Check if this is the companies category
        if (category.shortName === 'Companies' || category.shortName?.includes('Companies')) {
            navigate('/search/companies');
            return;
        }
        
        // For other categories, use the original callback
        onCategorySelect(category);
    };
    
    return (
        <BringzzBoxSlider className='space-x-2'>
            {categories.map((category, index) => (
                <div key={index} className={classNames(
                    'bg-sand h-10 cursor-pointer flex items-center px-3 rounded-full whitespace-nowrap',
                    'transition-all duration-300 hover:bg-magic-lilac/20',
                    category.shortName === activeCategory && '!bg-magic-lilac text-white'
                )}
                    onClick={() => handleCategoryClick(category)}
                >
                    <div className='flex items-center gap-2'>
                        <div className={classNames(
                            'flex items-center justify-center',
                            category.shortName === activeCategory ? 'text-white' : 'text-magic-lilac'
                        )}>
                            {React.cloneElement(category.icon, {
                                size: "20",
                                className: classNames(
                                    'transition-colors duration-300',
                                    category.shortName === activeCategory ? 'text-white' : 'text-magic-lilac'
                                )
                            })}
                        </div>
                        <BringzzText 
                            tag='h4' 
                            className={classNames(
                                'font-medium transition-colors duration-300',
                                category.shortName === activeCategory ? 'text-white' : 'text-gray-800'
                            )}
                        >
                            {category.shortName}
                        </BringzzText>
                    </div>
                </div>
            ))}
        </BringzzBoxSlider>
    );
};

export default CategorySlider; 